enum ParkingPrebookingAvailabilityType {
	Undefined = 0,
	Available = 1,
	AlreadyBooked = 2,
	NoFreeSpaces = 3,
	NotAvailable = 4
}

export default ParkingPrebookingAvailabilityType;
